export default {
  "content": "<path d=\"M9.667 19.308V12.5h-6.6L11.333.692V7.5h6.6L9.667 19.308z\" fill=\"#fff\"/>",
  "attrs": {
    "width": "21",
    "height": "20",
    "viewBox": "0 0 21 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};